import { getRefBancaria } from "./getRefBancaria";

export const generateRef = (props) => {

    const { prefix } = props;
    // console.log(prefix);     

    const dateStr = String(Date.now());
    const entry = dateStr.substring(1,11);
    // console.log(entry);     
    // console.log(entry.length);     

    const result = getRefBancaria(prefix + entry);
    // console.log(result);
    // console.log("refLength", result.length); 
     
    return result;
};
     